import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.analysis.dashboard');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-analysis-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.analysis.dashboard/view.scss */
/* src/app/portal.analysis.dashboard/view.scss: no such file or directory */`],
})
export class PortalAnalysisDashboardComponent implements OnInit {
    @Input() data!: ResearcherData;
    public period: any;
    public years: number[] = [];

    constructor(@Inject( Service)         public service: Service,    ) { }

    public async ngOnInit() {
    }

    onYearsChange(years: number[]) {
        this.years = years ?? [];

        if (this.years.length > 0) {

            this.period = {
                start: this.years[0],
                end: this.years[this.years.length - 1]
            };
        } else {
            this.period = { start: null, end: null };
        }
    }
}

export default PortalAnalysisDashboardComponent;